import { ResizeCallback } from 're-resizable';
import { Direction } from 're-resizable/lib/resizer';
import { useCallback, useState } from 'react';
type Size = { width: number; height: number };
type Pos = {
	right: number;
	bottom: number;
};

export const useResize = (
	setSizes: (s: Partial<Size>) => void,
	setPos: (pos: Pos) => void,
	pos: Pos | null
): ResizeCallback => {
	const [state] = useState({ w: 0, h: 0, pos });

	state.pos = pos;

	const onResize = useCallback(
		(e: MouseEvent, direction: Direction, elementRef: HTMLElement) => {
			if (/left/i.test(direction) && e.clientX > 0) {
				setSizes({
					width: elementRef.clientWidth,
				});
			}

			if (/top/i.test(direction) && e.clientY > 0) {
				setSizes({
					height: elementRef.clientHeight,
				});
			}

			if (/right/i.test(direction) && e.clientX < window.innerWidth) {
				setSizes({ width: elementRef.clientWidth });
			}

			if (/bottom/i.test(direction) && e.clientY < window.innerHeight) {
				setSizes({ height: elementRef.clientHeight });
			}

			if (state.pos) {
				let changed = 0;
				const newState = {
					bottom: state.pos?.bottom,
					right: state.pos?.right,
				};
				if (state.w && /right/i.test(direction)) {
					const calculated = (state.pos?.right || 0) - (elementRef.clientWidth - state.w);
					if (calculated < 0) {
						return;
					}
					newState.right = calculated;
					changed++;
				}
				if (state.h && /bottom/i.test(direction)) {
					const calculated = (state.pos?.bottom || 0) - (elementRef.clientHeight - state.h);
					if (calculated < 0) {
						return;
					}
					newState.bottom = calculated;
					changed++;
				}
				if (changed) {
					setPos(newState);
				}
			}

			state.h = elementRef.clientHeight;
			state.w = elementRef.clientWidth;
		},
		[setPos, setSizes, state]
	);

	return onResize as ResizeCallback;
};
